import { getAddedNodes } from '../observer';

/**
 *  Returns child node with text
 */
export const findChildNodeByText = (text: string) => (node: Node) => {
  if (!node) {
    return null;
  }

  const element = node as HTMLElement;
  const childs = [...element.querySelectorAll('*')];
  return childs.find((child) => child.textContent === text);
};

/**
 *  Returns the found child node
 */
export const findNodeByText = async (text: string, parentNode = document.body) => {
  const addedNodes = await getAddedNodes(parentNode);
  return addedNodes.map(findChildNodeByText(text)).find((child) => !!child);
};
